import { type TextareaHTMLAttributes, forwardRef } from "react";

import { clsx } from "clsx";

import { FIELD_STATE_STYLE, FIELD_STYLE } from "./config";
import { FormState } from "./types";

type T = HTMLTextAreaElement;
type P = Omit<TextareaHTMLAttributes<T>, "className"> & {
  // `line` starts at one line, `block` at a few; both grow with the text.
  size?: "line" | "block";
  invalid?: boolean;
};

// A settings panel's text field: 13px, no resize handle, as tall as its text.
export const CompactTextArea = forwardRef<T, P>(
  ({ size = "block", invalid = false, ...props }, ref) => (
    <textarea
      ref={ref}
      className={clsx(
        FIELD_STYLE,
        FIELD_STATE_STYLE[invalid ? FormState.Error : FormState.Default],
        "field-sizing-content max-h-64 resize-none py-2 text-[13px] leading-normal",
        size === "line" ? "min-h-10" : "min-h-28",
      )}
      {...props}
    />
  ),
);

CompactTextArea.displayName = "CompactTextArea";
